import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.chart.projection.default.background,
      padding: spacing.m,
      borderRadius: constants.radius.view,
    },
    header: {
      color: theme.chart.projection.default.text,
      textAlign: "center",
    },
    footer: {
      backgroundColor: theme.chart.projection.default.footer,
      borderRadius: 16,
    },
  };

  return styles;
};
